export default __webpack_public_path__ + "static/media/condumex.9b0196e3.svg";